'use strict';

(function (angular) {
    'use strict';

    angular.module('zp.api').service('zpAPI', zpAPI);

    /** @ngInject */
    function zpAPI($http, config, $localStorage) {

        var service = this;

        service.http = http;

        //////////////////////////////////

        function http(params) {

            params.url = config.zpAPI.HOST + params.url;

            if (!!$localStorage.current_user && !!$localStorage.current_user.token) {
                if (!params.headers) {
                    params.headers = {};
                }
                params.headers.Authorization = 'Bearer ' + $localStorage.current_user.token;
            }

            return $http(params).then(function (response) {
                return response.data;
            });
        }
    }
})(window.angular);